module.exports = __webpack_public_path__ + "static/assets/40fd427372e92054c79346922683a80a.gif";